import React from 'react'
import Container from '@orionx-dev/orionsoft-parts/lib/components/Container'
import Paginated from '@orionx-dev/meteor-paginated-graphql-react'
import styles from './styles.css'
import UnderscoreLink from 'App/components/UnderscoreLink'

export default class Main extends React.Component {
  static propTypes = {}

  getFields() {
    return [
      {
        title: 'Valor del ticket',
        name: 'value'
      }
    ]
  }

  redirectTo(url) {
    window.open(url, '_blank')
  }

  render() {
    return (
      <Container>
        <h1>Tercera parte concurso de Holding DASH</h1>
        <p>
          A la fecha de corte 29 de septiembre a las 00.00 AM (Horario de Chile), estos son los
          tickets generados por tu holding de DASH en la wallet de Orionx.
        </p>
        <p>Próximo corte: 7 de octubre a las 00.00 AM (Horario de Chile).</p>
        <UnderscoreLink
          onClick={() => this.redirectTo('https://www.youtube.com/watch?v=ihkLmqjOg2w')}>
          Revisa los tickets ganadores
        </UnderscoreLink>
        <br />
        <UnderscoreLink
          onClick={() =>
            this.redirectTo(
              'https://medium.com/orionx/orionx-reparte-45-dash-entre-sus-usuarios-cdbdfbc9cbdd'
            )
          }>
          Revisa las bases del concurso
        </UnderscoreLink>
        <br />
        <div className={styles.box}>
          <Paginated
            headTitle="Tickets"
            queryName="tickets"
            fields={this.getFields()}
            params="$filter: String"
          />
        </div>
      </Container>
    )
  }
}
